import { render, staticRenderFns } from "./fccCidades.vue?vue&type=template&id=20ce4ea8"
import script from "./fccCidades.vue?vue&type=script&lang=js"
export * from "./fccCidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports